import React from 'react';

const MainLayout = ({ children }) => {
  return (
    <div className="container" style={{ paddingTop: '12px', maxWidth: '1130px', margin: '0 auto' }}>
      {children}
    </div>
  );
};

export default MainLayout;
